import React, { useEffect, useState } from 'react';
import * as DateFns from 'date-fns';
import { Link, useLocation } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';

import { cleanFetch, formatDateRoute, routeToDate } from '../../../../helpers';
import { FORMAT_DATE_ROUTE, MONTHS_LITERALS, SCOPE, YEARS } from '../../../../config/constants';
import { routeToScope } from '../../../../helpers';

import './styles.scss';

export const WeekSelector = () => {
  
  const { pathname } = useLocation();
  const selectedDate = routeToDate(pathname);
  const scope = routeToScope(pathname);
  const [selectedYear, setYear] = useState(DateFns.getYear(selectedDate));
  const [selectedMonth, setMonth] = useState(DateFns.getMonth(selectedDate));
  const [show, setShow] = useState(false);
  
  useEffect(() => {
    if (DateFns.isDate(selectedDate)) {
      setYear(DateFns.getYear(selectedDate));
      setMonth(DateFns.getMonth(selectedDate));
    }
  }, [pathname]);
  
  const yearsRadios = [...YEARS].reverse().map((year, index) => {
    return <li key={index} className={selectedYear === year ? 'selected-label-week' : ''}>
      <label>
        <div className="radio radio-week">
          <input id={'' + year} name="radio" type="radio" value={year} checked={selectedYear === year}
                 onChange={() => setYear(year)} />
          <label htmlFor={'' + year} className="radio-label">{year}</label>
        </div>
      </label>
    </li>;
  });
  const monthsRadios = MONTHS_LITERALS.map((month, index) => {
    return <li key={index} className={selectedMonth === index ? 'selected-label-week' : ''}>
      <label>
        <div id={''} className="radio radio-week">
          <input id={month} name="radio-1" type="radio" value={index} checked={selectedMonth === index}
                 onChange={() => setMonth(index)} />
          <label htmlFor={month} className="radio-label">{month}</label>
        </div>
      </label>
    </li>;
  });
  
  const onOpen = () => {
    setShow(true);
    setYear(DateFns.getYear(selectedDate));
    setMonth(DateFns.getMonth(selectedDate));
  };
  const onClose = () => {
    setShow(false);
    setYear(DateFns.getYear(selectedDate));
    setMonth(DateFns.getMonth(selectedDate));
  };
  const toPrev = () => {
    const newDate = (scope === SCOPE.SCHEDULE.WEEK.PAGE ? DateFns.subWeeks(selectedDate, 1) : DateFns.subMonths(selectedDate, 1));
    return DateFns.format(new Date(newDate), FORMAT_DATE_ROUTE);
  };
  const toNext = () => {
    const newDate = (scope === SCOPE.SCHEDULE.WEEK.PAGE ? DateFns.addWeeks(selectedDate, 1) : DateFns.addMonths(selectedDate, 1));
    return DateFns.format(new Date(newDate), FORMAT_DATE_ROUTE);
  };
  
  return (
    <>
      <Link
        to={`/schedule/${scope === SCOPE.SCHEDULE.WEEK.PAGE ? 'week' : 'month'}/${toPrev()}`}
        onClick={() => cleanFetch()}
      >
        <div className="arrow-l" id={'selector-date-previous'}>
          <i className="mdi mdi-arrow-left" />
        </div>
      </Link>
      <Dropdown show={show} onToggle={show ? onClose : onOpen}>
        <Dropdown.Toggle id="dropdown-basic" className="btn-border btn-select-week">
          <div className="date-s" onClick={() => (setShow(!show))} id={'selector-date'}>
            <label className={'label-bold label-week-selector'}>
              {DateFns.format(new Date(selectedDate), 'MMMM')}
            </label>
            {` `}
            <label className={'label-week-selector'}>{DateFns.format(new Date(selectedDate), 'yyyy')}</label>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className={'dropdown-week-selector'} rootCloseEvent="click">
          <div className='week-selector-radios'>
            <div className="list-01">
              <ul>{yearsRadios}</ul>
            </div>
            <div className="list-02">
              <ul>{monthsRadios}</ul>
            </div>
          </div>
          <div className="footer-s">
            <button id={'button-cancel-selector'} className="btn-transparet" onClick={onClose}>
              Cancel
            </button>
            <Link
              to={`/schedule/${scope === SCOPE.SCHEDULE.WEEK.PAGE ? 'week' : 'month'}/${formatDateRoute(new Date(selectedYear, selectedMonth, 1))}`}
              onClick={() => {
                  if(selectedDate.getFullYear() !== selectedYear){
                    cleanFetch();
                  }else{
                    if(selectedDate.getMonth()+1 !== selectedMonth+1){
                      cleanFetch();
                    }
                  }
                }}
            >
              <button id={'button-apply-selector'} className="btn-blue" onClick={() => setShow(false)}>
                Apply
              </button>
            </Link>
          </div>
        </Dropdown.Menu>
      </Dropdown>
      <Link
        to={`/schedule/${scope === SCOPE.SCHEDULE.WEEK.PAGE ? 'week' : 'month'}/${toNext()}`}
        onClick={() => cleanFetch()}
      >
        <div className="arrow-r" id={'selector-date-next'}>
          <i className="mdi mdi-arrow-right" />
        </div>
      </Link>
    </>
  );
};

export default WeekSelector;